import Image from "next/image"
import ChartImg from "/public/charts-ss.png"
import { 
  AdjustmentsVerticalIcon,
  BoltIcon,
  LifebuoyIcon
} from "@heroicons/react/24/outline"

const features = [
  {
    name: 'Customized.',
    description: 'Each business is unique and our team customizes your report to your business so it\'s powerful for you.',
    icon: AdjustmentsVerticalIcon,
  },
  {
    name: 'Automatic.',
    description: 'Every month we close the books and generate your monthly financials so you can sit back and relax.',
    icon: BoltIcon,
  },
  {
    name: 'Knowledgeable Help.',
    description: 'Our team isn\'t just software. We are here for you, give you video recaps of your financials, meet with you when you need, and more.',
    icon: LifebuoyIcon,
  },
]


export default function FeaturesLeft() {
  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
              <h2 className="text-base font-semibold leading-7 text-pinto">Better visuals</h2>
              <p className="mt-2 text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl">Charts Tailored To You</p>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We customize each set of company metrics so you get the most important data for you.  
              </p>
              <dl className="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                {features.map((feature) => (
                  <div key={feature.name} className="relative pl-9">
                    <dt className="inline font-semibold text-gray-900">
                      <feature.icon className="absolute top-1 left-1 h-5 w-5 text-pinto" aria-hidden="true" />
                      {feature.name}
                    </dt>{' '}
                    <dd className="inline">{feature.description}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
          <Image
            src={ChartImg}
            alt="Pinto Charts"
            className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  )
}